import { render, staticRenderFns } from "./FilterOrder.vue?vue&type=template&id=2d487ff2&scoped=true"
import script from "./FilterOrder.vue?vue&type=script&lang=js"
export * from "./FilterOrder.vue?vue&type=script&lang=js"
import style0 from "./FilterOrder.vue?vue&type=style&index=0&id=2d487ff2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d487ff2",
  null
  
)

export default component.exports